import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'loyalityCalculator'
})
export class LoyalityCalculatorPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return null;
  }

}
